import React from 'react';

function SkeletonFeedCard() {
  return (
    <>
      <div className="card-col gap10">
        <div className="box-row pd0">
          <div className="group-align-left">
            <div className="skeleton-avatar skeleton-pulse" />
            <div className="skeleton-line skeleton-pulse skeleton-line-30 skeleton-line-sm" />
            <div className="skeleton-line skeleton-pulse skeleton-line-20 skeleton-line-sm" />
          </div>
        </div>
        <div className="skeleton-line skeleton-pulse skeleton-line-title skeleton-line-55" />
        <div className="skeleton-line skeleton-pulse skeleton-line-85" />
        <div className="skeleton-line skeleton-pulse skeleton-line-70 skeleton-line-sm" />
        <div className="skeleton-pulse" style={{ width: '100%', aspectRatio: '3/2', borderRadius: 8 }} />
        <div className="skeleton-card-actions">
          <div className="skeleton-pill skeleton-pulse" />
          <div className="skeleton-pill skeleton-pulse" />
          <div className="skeleton-pill skeleton-pulse" />
        </div>
      </div>
      <hr />
    </>
  );
}

export default SkeletonFeedCard;
